import router from '../services/router_service';
import forgotPasswordController from '../controllers/forgot_password_controller';

router.on('route:forgot-password', forgotPasswordController);
